const setRef = <T>(ref: React.RefCallback<T> | React.MutableRefObject<T> | null | undefined, value: T) => {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};

export const forkedRef =
  <T>(...refs: Array<React.RefCallback<T> | React.MutableRefObject<T> | null | undefined>): React.RefCallback<T> =>
  (value) => {
    for (const ref of refs) {
      setRef(ref, value);
    }
  };
